import { CheckoutSessionCriteria, formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { PendingBorrowerNameInformation } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/PendingBorrowerNameInformation';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useUser } from '@/hooks/useUser';

export const updatedAtWithCustomerNameFieldColumnMobile = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();

  const { userEntity } = useUser();

  const showMerchant = userEntity && !userEntity.isRoleMerchantChannelOrAgent();

  return {
    flex: flex ?? 0.6,
    field: 'updated_at',
    headerName: <Text tId={'UPDATE_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: { row: CheckoutSessionCriteria }) => {
      const customerName = rowData.row.customer?.fullName ? (
        `${rowData.row.customer.fullName.firstName} ${rowData.row.customer.fullName.lastName}`
      ) : (
        <PendingBorrowerNameInformation />
      );

      return (
        <div className={'overflow-text-ellipsis'}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Font color="textPrimary" variant="caption">
              <strong>{customerName}</strong>
            </Font>
          </div>
          <span style={{ color: palette.text.secondary }}>
            {showMerchant ? rowData.row.businessName : rowData.row.agentName}
          </span>
          <div className={'overflow-text-ellipsis'}>
            <Font color="textSecondary" variant={'caption'}>
              {formatDateTimeReadable(rowData.row.updatedAt)}
            </Font>
          </div>
        </div>
      );
    },
  };
};
